import { Input } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { isEnterKeyPress } from 'core/utils';

const InputCell = ({ value, setValue }: ICellRendererParams) => {
  const onInputChanged = (value: string | number) => setValue(value);

  return (
    <Input
      defaultValue={value}
      onChange={(event) => onInputChanged(event.target.value)}
      onKeyDown={(event) => (isEnterKeyPress(event) ? event.target.blur() : null)}
    />
  );
};

export default InputCell;
